// extracted by mini-css-extract-plugin
export var icon = "icon-module--icon--3a9c5";
export var rotate = "icon-module--rotate--b4599";
export var spinner = "icon-module--spinner--757f5";